// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Y37m7","footerContent":"Footer_footerContent__haIS4","contactInfo":"Footer_contactInfo__-HiWH","copyright":"Footer_copyright__3ov2N"};